import React from 'react'
import Button from './index'

const styles = {
    normal: {
        minWidth: '100px',
        backgroundColor: '#ff5e65',
        color: '#ffffff',
        '&:hover': {
            backgroundColor: '#ff5e65',
            opacity: 0.95,
        },
        '&:active': {
            backgroundColor: '#ff5e65',
        },
    },
    disabled: {
        backgroundColor: '#aab0b4 !important',
        color: '#ffffff !important',
    },
}

const ApplyFiltersButton = ({ ...rest }) => {
    return (
        <Button
            style={styles.normal}
            size="medium"
            disabledStyles={styles.disabled}
            {...rest}
        />
    )
}

export default ApplyFiltersButton
